import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { RolesService } from '@core/services/roles.service';
import { UsersService } from '@core/services/users.service';
import { UsersEditComponent } from '@modules/users/users-edit/users-edit.component';
import { User } from '@shared/interfaces/user';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html'
})
export class UsersListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public location = 'users';
  public dataSource: MatTableDataSource<User>;
  public selection = new SelectionModel<User>(true, []);
  public usersList: Array<User> = [];
  public user: User;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public usersService: UsersService,
    public rolesService: RolesService
  ) {
    this.constants.displayedColumns = [
      this.appConfig.ACTIONS.delete.id,
      'id',
      'name',
      'idRol',
      'rol',
      this.appConfig.ACTIONS.edit.id
    ];
  }

  ngOnInit() {
    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result) {
          const actions = this.generalsService.getActions(
            this.constants.displayedColumns,
            this.constants.actionsList,
            this.location
          );

          this.constants.displayedColumns = actions.displayedColumns;
          this.constants.displayedActions = actions.displayedActions;
          this.loadData();
        }
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constants.loading = true;
    this.constants.elements = true;
    this.usersService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.usersList = [];
          result.data.forEach((element: any) => {
            this.user = {
              id: element['id'],
              name: element.attributes['username'],
              idRol: element.attributes['role-id'],
              rol: element.attributes['role-name']
            };
            this.usersList.push(this.user);
          });
          if (this.usersList.length) {
            this.dataSource = new MatTableDataSource(this.usersList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(action: string, item?: User) {
    let dialog: any;

    const data = {
      action: action,
      item: {},
      relationships: {}
    };

    const loading = this.generalsService.loading();
    this.rolesService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          let res = false;
          loading.close();
          if (!result.data || result.data.length <= 0) {
            res = true;
          }

          if (action === this.appConfig.ACTIONS.add.id && res) {
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.appConfig.LANG.roles.noRoles
            );
          } else {
            if (action === this.appConfig.ACTIONS.add.id) {
              this.constants.message = this.appConfig.LANG.message.addSuccess;
            } else {
              data.item = item;
              this.constants.message = this.appConfig.LANG.message.editSuccess;
            }

            data.relationships = result.data;
            dialog = this.generalsService.modal(UsersEditComponent, data);

            dialog
              .afterClosed()
              .pipe(takeUntil(this.constants.destroy$))
              .subscribe((afterClosedResult: any) => {
                this.generalsService.afterClosed(
                  this,
                  afterClosedResult,
                  this.constants.message
                );
              });
          }
        },
        error => {
          loading.close();
          this.generalsService.notification(
            this.appConfig.NOTIFICATION.error,
            this.generalsService.showError(error)
          );
        }
      );
  }

  selectDelete() {
    const numSelected = this.selection.selected.length,
      numRows = this.dataSource.data.length;

    this.constants.labelDelete = this.generalsService.messageSelectedDelete(
      'label',
      numSelected,
      numRows
    );
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }

  export() {
    this.generalsService.export('usuarios', this.debugExport());
  }

  debugExport(): string {
    let result = 'USUARIO;ROL\n';
    this.usersList.forEach(element => {
      result = result + element.name + ';' + element.rol + '\n';
    });
    return result;
  }
}
